<template>
    <div class="posts-wrapper">
      <div class="packages reports">
        <div class="filters">
          <div class="title">Búsqueda</div>
          <div class="wrap-filter">
              <div class="item">
                <label for="">Fechas</label>
                <v-date-picker mode="range" v-model="dateFilter" locale="es" :popover="{ placement: 'top', visibility: 'click' }"></v-date-picker>
              </div>
              <div class="item btnFilter">
                  <vs-button id="btnFilter" class="vs-con-loading__container"  color="primary" type="border" icon="search" @click="retrievePackages()">Filtrar paquetes</vs-button>
              </div>
              <div class="item full-2">
                  <vs-button id="btnDownloadPacks" class="vs-con-loading__container" @click="downloadPackagesReport" color="primary" 
                            type="border" icon="cloud_download">Descargar</vs-button>
                  <vs-button id="btnDownloadCustomers" class="vs-con-loading__container" @click="downloadMatrixCustomers" color="primary" 
                            type="border" icon="cloud_download">Matrix Customers</vs-button>
                  <vs-button id="btnDownloadMonths" class="vs-con-loading__container" @click="downloadMatrixMonth" color="primary" 
                            type="border" icon="cloud_download">Matrix Month</vs-button>
              </div>                    
          </div>
        </div>
        <div class="box-white-wrapper" v-if="packages.length > 0">
          <vs-table :data="packages" pagination max-items="50" :key="key">
              <template slot="thead">
                  <vs-th sort-key="tracking">Tracking</vs-th>
                  <vs-th sort-key="customername">Nombre </vs-th>
                  <vs-th sort-key="weight">Peso </vs-th>
                  <vs-th sort-key="feTotalTrasporte">  Transporte </vs-th>
                  <vs-th sort-key="feTaxesTotal"> Impuestos </vs-th>
                  <vs-th sort-key="feTotalOtros"> Otros Costos </vs-th>
                  <vs-th sort-key="feTotal"> Total </vs-th>
                  <vs-th sort-key="regDate"> Fecha Ingreso </vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].tracking"> 
                        <router-link :to="`/package/${data[indextr].id}`">{{data[indextr].tracking}} </router-link>                              
                    </vs-td>
                    <vs-td :data="data[indextr].customername">
                        {{ data[indextr].customername}} 
                    </vs-td>
                    <vs-td :data="data[indextr].weight">
                        {{ data[indextr].weight +" "+ data[indextr].unit }}
                    </vs-td>
                    <vs-td :data="data[indextr].feTotalTrasporte"> 
                        {{ formatNumber(data[indextr].feTotalTrasporte) }} USD 
                    </vs-td>
                    <vs-td :data="data[indextr].taxes"> 
                        {{ formatNumber(data[indextr].feTaxesTotal) }} USD 
                    </vs-td>
                    <vs-td :data="data[indextr].otherCosts"> 
                        {{ formatNumber(data[indextr].feTotalOtros)}} USD 
                    </vs-td>
                    <vs-td :data="data[indextr].total"> 
                        {{ formatNumber(data[indextr].feTotal) }} USD 
                    </vs-td>
                    <vs-td :data="data[indextr].regDate">
                        {{data[indextr].regDate | moment('DD/MM/YYYY')}}
                    </vs-td>
                  </vs-tr>
              </template>
          </vs-table>
        </div>
      </div>
      <displayInformation v-if="packages.length < 1" message="No se han encontrado paquetes registrados." :showButton="true"></displayInformation>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import PackageDataService from "@/services/PackageDataService"
import DisplayInformation from '@/components/DisplayInformation.vue'
export default {
  name: 'Packages',
  mixins: [helper],
  components: {
    DisplayInformation
  },
  data () {
    return {
      key: 1,
      dateFilter: '',
      packages: [],
      filterObj: {
        dateFilter: null,
        status: null,
        filter: ""
      }
    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.retrievePackages()
  },
  methods: {
    retrievePackages() {
        let _dateFilter =  this.dateFilter != '' && this.dateFilter != null ?  this.dateFilter : null
        this.filterObj.dateFilter = _dateFilter != null ? { 
            end: this.$moment(this.dateFilter.end).format('YYYY/MM/DD'), 
            start: this.$moment(this.dateFilter.start).format('YYYY/MM/DD')
          } : null;
        this.loadingProgress ('#btnFilter', "#1a426d")
        PackageDataService.reportSales(this.filterObj)
        .then(response => {
          this.packages    = response.data;
          this.$Progress.finish()
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          this.key++
        })
        .catch(e => {
          console.log(e)
          this.$Progress.finish()
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    },
    downloadPackagesReport(){
        const that = this
        that.loadingProgress ('#btnDownloadPacks', 'primary')
        that.confirmStatus = true
        let _dateFilter =  this.dateFilter != '' && this.dateFilter != null ?  this.dateFilter : null
        this.filterObj.dateFilter = _dateFilter != null ? { 
            end: this.$moment(this.dateFilter.end).format('YYYY/MM/DD'), 
            start: this.$moment(this.dateFilter.start).format('YYYY/MM/DD')
          } : null;
        this.filterObj.status = this.boxActive
        this.filterObj.filter = this.keyword
        
        PackageDataService.downloadReportSales(this.filterObj)
        .then(response => {
            console.log(response.data)
            that.confirmStatus = false
            let blob = new Blob([response.data], { type: "application/vnd.ms-excel" }); 
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "Sales.xlsx";
            a.click();
            window.URL.revokeObjectURL(url)
            that.$vs.loading.close('#btnDownloadPacks .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'La descarga de los paquetes ha iniciado!',color:'success',icon:'check'})
            
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error descargado los paquetes!',color:'danger',icon:'error_outline'})                
        });
    },
    downloadMatrixCustomers(){
        const that = this
        that.loadingProgress ('#btnDownloadCustomers', 'primary')
        that.confirmStatus = true
        // let _dateFilter =  this.dateFilter != '' && this.dateFilter != null ?  this.dateFilter : null
        // this.filterObj.dateFilter = _dateFilter != null ? { 
        //     end: this.$moment(this.dateFilter.end).format('YYYY/MM/DD'), 
        //     start: this.$moment(this.dateFilter.start).format('YYYY/MM/DD')
        //   } : null;
        // this.filterObj.status = this.boxActive
        // this.filterObj.filter = this.keyword
        
        PackageDataService.matrixCustomers()
        .then(response => {
            console.log(response.data)
            that.confirmStatus = false
            let blob = new Blob([response.data], { type: "application/vnd.ms-excel" }); 
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "matrixCustomers.xlsx";
            a.click();
            window.URL.revokeObjectURL(url)
            that.$vs.loading.close('#btnDownloadCustomers .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'La descarga de los paquetes ha iniciado!',color:'success',icon:'check'})
            
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error descargado los paquetes!',color:'danger',icon:'error_outline'})                
        });
    },

    downloadMatrixMonth(){
        const that = this
        that.loadingProgress ('#btnDownloadMonths', 'primary')
        that.confirmStatus = true
        PackageDataService.matrixMonth()
        .then(response => {
            console.log(response.data)
            that.confirmStatus = false
            let blob = new Blob([response.data], { type: "application/vnd.ms-excel" }); 
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "matrixMonth.xlsx";
            a.click();
            window.URL.revokeObjectURL(url)
            that.$vs.loading.close('#btnDownloadMonths .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'La descarga de los paquetes ha iniciado!',color:'success',icon:'check'})
            
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error descargado los paquetes!',color:'danger',icon:'error_outline'})                
        });
    }
  }
}
</script>
